/* eslint-disable quotes */
import ApiService from "./api.service";
// import ApiMockService from "./api.mock.service"

/**
 * SupplementService es un objeto que almacena las funciones
 *
 * getAll --> función que realiza una petición ._GET al enterpoint, la cual le solicita el listado de suplementos
 * retorna el listado de suplementos
 *
 * getSuplement --> función que realiza una petición GET al enterpoint,la cual le solicita un suplemento en específico
 * retorna el suplemento
 *
 * getCategories --> función que realiza una petición GET al enterpoint,la cual le solicita el listado de categorias de los suplemento
 * retorna las categorías
 *
 * getBrands --> función que realiza una petición GET al enterpoint,la cual le solicita el listado de marcas de suplementos
 * retorna las marcas
 *
 * save --> función que realiza una petición POST al enterpoint,la cual le solicita crear o actualizar un nuevo sumplentos
 * retorna mensaje de exito o error
 *
 * saveCategory --> función que realiza una petición POST al enterpoint,la cual le solicita crear o actualizar una categoría de suplementos
 * retorna mensaje de exito o error
 *
 * getInteractionSupplement --> función que realiza una petición ._GET al enterpoint,la cual le solicita la interacción entre los suplementos
 * retorna la interacción
 *
 * saveInteractionSupplement --> función que realiza una petición POST al enterpoint,la cual le solicita crear o actualizar la interacción  entre los suplementos
 * retorna mensaje de éxito o error
 *
 *deleteInteractionSupplement --> función que realiza una petición POST al enterpoint,la cual le solicita eliminar la interacción  entre los suplementos
 * retorna mensaje de éxito o error
 *
 */

const SupplementService = {
  getAll: async function (params) {
    const response = await ApiService._get("api/admin/suplement", params);
    // Temporal Local Storage: start
    const itemLS = localStorage.getItem("substances");
    let supplementsLS = [];
    if (itemLS) {
      try {
        console.log("Parsing supplements from localStorage", itemLS);
        supplementsLS = JSON.parse(itemLS);
      } catch (error) {
        console.error("Error parsing supplements from localStorage:", error);
        supplementsLS = [];
      }
    }
    const supplementDB = response.data.data ?? response.data ?? [];
    const allSupplements = [...supplementsLS, ...supplementDB];
    return allSupplements;
    // Temporal Local Storage: end
    // return response.data
  },

  getSupplement: async function (id, lang = null) {
    // const response = await ApiService.get("/api/admin/suplement/" + id, lang)
    // return response.data
    return {};
  },
  getCategories: async function (lang = null) {
    const response = await ApiService.get("api/admin/suplement/categories", lang);
    return response.data;
  },

  save: async function (params, lang = null) {
    // const response = await ApiService.post(
    //   "/api/admin/suplement/supplement",
    //   params,
    //   lang
    // )
    // return response.data
    return {};
  },

  saveCategory: async function (params, lang = null) {
    // const response = await ApiService.post(
    //   "/api/admin/suplement/create_category",
    //   params,
    //   lang
    // )
    // return response.data
  },

  getInteractionSupplement: async function (params, lang = null) {
    const response = await ApiService._get("api/admin/suplement/get-supplement-interaction", params, lang);
    return response.data;
    return {};
  },

  saveInteractionSupplement: async function (params, lang = null) {
    const response = await ApiService.post("api/admin/suplement/save-supplement-interaction", params, lang);
    return response.data;
  },

  deleteInteractionSupplement: async function (params, lang = null) {
    // const response = await ApiService.post(
    //   "/api/admin/suplement/delete-supplement-interaction",
    //   params,
    //   lang
    // )
    // return response.data
    return {};
  },

  /**
   * Deletes a list of interactions between a supplement and others supplements.
   * @param {*} params.supplementId Supplement ID
   * @param {*} params.ids Array of interaction IDs to delete
   * @returns API response
   */
  deleteListOfSupplementsPerOtherSupplement: async function (params) {
    const response = await ApiService.post("api/admin/suplement/delete-list-supplement-interaction", params);
    return response.data;
  },
};

export default SupplementService;
